// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
// import { getDashboardStats } from '../utils/api';

// const StatCard = ({ label, value, sub, icon, color, to }) => (
//   <Link to={to} className="card p-5 flex items-start gap-4 hover:border-surface-600 transition-colors group">
//     <div className={`w-11 h-11 rounded-lg flex items-center justify-center text-xl flex-shrink-0 ${color}`}>{icon}</div>
//     <div className="flex-1 min-w-0">
//       <p className="text-surface-500 text-xs uppercase tracking-wide mb-1">{label}</p>
//       <p className="text-2xl font-display font-semibold text-surface-100">{value}</p>
//       {sub && <p className="text-surface-500 text-xs mt-0.5">{sub}</p>}
//     </div>
//     <span className="text-surface-600 group-hover:text-brand-400 transition-colors text-sm">→</span>
//   </Link>
// );

// const STATUS_COLORS = { New: '#3b82f6', Contacted: '#22c55e', 'In Progress': '#f59e0b', Closed: '#6b7280' };
// const PIE_COLORS = ['#f5c518', '#d4a017', '#a07810', '#7a5c0c', '#5c4309', '#3d2d06', '#ffd11a', '#ffe066'];

// export default function DashboardPage() {
//   const [stats, setStats] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     getDashboardStats()
//       .then(r => setStats(r.data.data))
//       .catch(() => {})
//       .finally(() => setLoading(false));
//   }, []);

//   if (loading) return (
//     <div className="space-y-6 animate-pulse">
//       <div className="h-8 bg-surface-700 rounded w-48" />
//       <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
//         {[...Array(4)].map((_, i) => <div key={i} className="card h-28" />)}
//       </div>
//     </div>
//   );

//   const monthlyData = (stats?.monthlyQuotations || []).reverse().map(m => ({
//     name: new Date(m._id.year, m._id.month - 1).toLocaleDateString('en', { month: 'short' }),
//     quotations: m.count
//   }));

//   const statusCounts = {};
//   // Use hardcoded mock if no data
//   ['New', 'Contacted', 'In Progress', 'Closed'].forEach(s => statusCounts[s] = 0);
//   if (stats?.quotations) {
//     statusCounts['New'] = stats.quotations.new || 0;
//     statusCounts['Contacted'] = stats.quotations.contacted || 0;
//   }

//   const getBadgeClass = (status) => {
//     const map = { New: 'badge-new', Contacted: 'badge-contacted', 'In Progress': 'badge-progress', Closed: 'badge-closed' };
//     return map[status] || 'badge-closed';
//   };

//   return (
//     <div className="space-y-6">
//       {/* Header */}
//       <div>
//         <h1 className="font-display text-xl font-semibold text-surface-100">Dashboard</h1>
//         <p className="text-surface-500 text-sm mt-0.5">Overview of your portfolio and enquiries</p>
//       </div>

//       {/* Stat cards */}
//       <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
//         <StatCard to="/projects" icon="◻" label="Total Projects" value={stats?.projects?.total || 0}
//           sub={`${stats?.projects?.published || 0} published`} color="bg-brand-400/15 text-brand-400" />
//         <StatCard to="/quotations" icon="◎" label="Quotation Requests" value={stats?.quotations?.total || 0}
//           sub={`${stats?.quotations?.new || 0} new`} color="bg-blue-500/15 text-blue-400" />
//         <StatCard to="/contacts" icon="◉" label="Messages" value={stats?.contacts?.total || 0}
//           sub={`${stats?.contacts?.unread || 0} unread`} color="bg-purple-500/15 text-purple-400" />
//         <StatCard to="/projects" icon="★" label="Featured" value={stats?.projects?.featured || 0}
//           sub="featured projects" color="bg-amber-500/15 text-amber-400" />
//       </div>

//       {/* Charts row */}
//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//         {/* Monthly quotations bar chart */}
//         <div className="card p-5 lg:col-span-2">
//           <h3 className="text-surface-300 font-medium text-sm mb-4">Quotations – Last 6 Months</h3>
//           {monthlyData.length > 0 ? (
//             <ResponsiveContainer width="100%" height={180}>
//               <BarChart data={monthlyData} barSize={28}>
//                 <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fill: '#8b949e', fontSize: 12 }} />
//                 <YAxis axisLine={false} tickLine={false} tick={{ fill: '#8b949e', fontSize: 12 }} allowDecimals={false} />
//                 <Tooltip contentStyle={{ background: '#161b22', border: '1px solid #30363d', borderRadius: '6px', color: '#c9d1d9' }} cursor={{ fill: '#30363d' }} />
//                 <Bar dataKey="quotations" fill="#f5c518" radius={[3, 3, 0, 0]} />
//               </BarChart>
//             </ResponsiveContainer>
//           ) : (
//             <div className="h-44 flex items-center justify-center text-surface-600 text-sm">No data yet</div>
//           )}
//         </div>

//         {/* Category pie chart */}
//         <div className="card p-5">
//           <h3 className="text-surface-300 font-medium text-sm mb-4">Projects by Category</h3>
//           {stats?.categoryStats?.length > 0 ? (
//             <>
//               <ResponsiveContainer width="100%" height={140}>
//                 <PieChart>
//                   <Pie data={stats.categoryStats} dataKey="count" nameKey="_id" cx="50%" cy="50%" outerRadius={60} innerRadius={30}>
//                     {stats.categoryStats.map((_, i) => <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />)}
//                   </Pie>
//                   <Tooltip contentStyle={{ background: '#161b22', border: '1px solid #30363d', borderRadius: '6px', color: '#c9d1d9', fontSize: '12px' }} />
//                 </PieChart>
//               </ResponsiveContainer>
//               <div className="space-y-1 mt-2">
//                 {stats.categoryStats.slice(0, 4).map((cat, i) => (
//                   <div key={cat._id} className="flex items-center justify-between text-xs">
//                     <div className="flex items-center gap-2">
//                       <span className="w-2 h-2 rounded-full" style={{ background: PIE_COLORS[i % PIE_COLORS.length] }} />
//                       <span className="text-surface-400">{cat._id}</span>
//                     </div>
//                     <span className="text-surface-300 font-medium">{cat.count}</span>
//                   </div>
//                 ))}
//               </div>
//             </>
//           ) : (
//             <div className="h-44 flex items-center justify-center text-surface-600 text-sm">No data yet</div>
//           )}
//         </div>
//       </div>

//       {/* Recent tables */}
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//         {/* Recent Quotations */}
//         <div className="card">
//           <div className="flex items-center justify-between px-5 py-4 border-b border-surface-700">
//             <h3 className="text-surface-300 font-medium text-sm">Recent Quotations</h3>
//             <Link to="/quotations" className="text-brand-400 hover:text-brand-300 text-xs transition-colors">View all →</Link>
//           </div>
//           <div className="divide-y divide-surface-700">
//             {stats?.recentQuotations?.length > 0 ? stats.recentQuotations.map(q => (
//               <div key={q._id} className="px-5 py-3 flex items-center justify-between gap-3">
//                 <div className="flex-1 min-w-0">
//                   <p className="text-surface-200 text-sm font-medium truncate">{q.name}</p>
//                   <p className="text-surface-500 text-xs">{q.projectType} · {q.phone}</p>
//                 </div>
//                 <span className={getBadgeClass(q.status)}>{q.status}</span>
//               </div>
//             )) : (
//               <div className="px-5 py-8 text-center text-surface-600 text-sm">No quotations yet</div>
//             )}
//           </div>
//         </div>

//         {/* Recent Projects */}
//         <div className="card">
//           <div className="flex items-center justify-between px-5 py-4 border-b border-surface-700">
//             <h3 className="text-surface-300 font-medium text-sm">Recent Projects</h3>
//             <Link to="/projects" className="text-brand-400 hover:text-brand-300 text-xs transition-colors">View all →</Link>
//           </div>
//           <div className="divide-y divide-surface-700">
//             {stats?.recentProjects?.length > 0 ? stats.recentProjects.map(p => (
//               <div key={p._id} className="px-5 py-3 flex items-center justify-between gap-3">
//                 <div className="flex-1 min-w-0">
//                   <p className="text-surface-200 text-sm font-medium truncate">{p.title}</p>
//                   <p className="text-surface-500 text-xs">{p.category} · {p.location}</p>
//                 </div>
//                 <span className={`text-xs px-2 py-0.5 rounded-full ${p.isPublished ? 'bg-green-500/15 text-green-400' : 'bg-surface-700 text-surface-500'}`}>
//                   {p.isPublished ? 'Live' : 'Draft'}
//                 </span>
//               </div>
//             )) : (
//               <div className="px-5 py-8 text-center text-surface-600 text-sm">No projects yet</div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


// import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { FolderKanban, FileText, MessageSquare, Star, TrendingUp, Clock, ChevronRight, Activity } from 'lucide-react';
// import { getDashboardStats } from '../utils/api';
// import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';

// function StatCard({ icon: Icon, label, value, sub, color = 'primary', to }) {
//   const colors = {
//     primary: 'bg-primary-500/10 text-primary-400 border-primary-500/20',
//     blue:    'bg-blue-500/10 text-blue-400 border-blue-500/20',
//     green:   'bg-green-500/10 text-green-400 border-green-500/20',
//     purple:  'bg-purple-500/10 text-purple-400 border-purple-500/20',
//   };
//   const content = (
//     <div className="card p-5 hover:border-white/15 transition-colors">
//       <div className="flex items-start justify-between mb-4">
//         <div className={`p-2.5 rounded-xl border ${colors[color]}`}>
//           <Icon size={18} />
//         </div>
//         {to && <ChevronRight size={14} className="text-white/20" />}
//       </div>
//       <div className="text-2xl font-bold text-white mb-0.5">{value}</div>
//       <div className="text-white/50 text-sm">{label}</div>
//       {sub && <div className="text-xs text-white/30 mt-1">{sub}</div>}
//     </div>
//   );
//   return to ? <Link to={to}>{content}</Link> : content;
// }

// function SkeletonStat() {
//   return (
//     <div className="card p-5">
//       <div className="skeleton h-10 w-10 rounded-xl mb-4" />
//       <div className="skeleton h-7 w-16 rounded mb-1" />
//       <div className="skeleton h-4 w-24 rounded" />
//     </div>
//   );
// }

// const CHART_COLORS = ['#dc7b28', '#e49446', '#f5d6ad', '#aa4a1a', '#cd621d', '#faecd6'];

// export default function DashboardPage() {
//   const [stats, setStats] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     getDashboardStats().then(r => setStats(r.data.data)).catch(console.error).finally(() => setLoading(false));
//   }, []);

//   const chartData = stats?.projects_by_type?.map((item, i) => ({
//     name: item.project_type,
//     count: item.count,
//   })) || [];

//   return (
//     <div>
//       <div className="mb-6">
//         <h1 className="text-xl font-semibold text-white">Dashboard</h1>
//         <p className="text-white/40 text-sm mt-0.5">Overview of your portfolio platform</p>
//       </div>

//       {/* Stats Grid */}
//       <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
//         {loading ? (
//           [...Array(4)].map((_, i) => <SkeletonStat key={i} />)
//         ) : (
//           <>
//             <StatCard icon={FolderKanban} label="Total Projects" value={stats?.total_projects || 0} sub={`${stats?.active_projects} active`} color="primary" to="/projects" />
//             <StatCard icon={FileText} label="Quotations" value={stats?.total_quotations || 0} sub={`${stats?.new_quotations} new`} color="blue" to="/quotations" />
//             <StatCard icon={MessageSquare} label="Contacts" value={stats?.total_contacts || 0} sub={`${stats?.unread_contacts} unread`} color="green" to="/contacts" />
//             <StatCard icon={Star} label="Featured" value={stats?.featured_projects || 0} sub="featured projects" color="purple" to="/projects" />
//           </>
//         )}
//       </div>

//       <div className="grid lg:grid-cols-3 gap-4">
//         {/* Chart */}
//         <div className="card p-5 lg:col-span-1">
//           <div className="flex items-center gap-2 mb-4">
//             <TrendingUp size={15} className="text-primary-400" />
//             <h3 className="font-medium text-white text-sm">Projects by Type</h3>
//           </div>
//           {loading ? (
//             <div className="skeleton h-40 rounded" />
//           ) : chartData.length > 0 ? (
//             <ResponsiveContainer width="100%" height={160}>
//               <BarChart data={chartData} margin={{ top: 0, right: 0, left: -20, bottom: 0 }}>
//                 <XAxis dataKey="name" tick={{ fill: 'rgba(255,255,255,0.3)', fontSize: 10 }} axisLine={false} tickLine={false} />
//                 <YAxis tick={{ fill: 'rgba(255,255,255,0.3)', fontSize: 10 }} axisLine={false} tickLine={false} />
//                 <Tooltip
//                   contentStyle={{ background: '#252d3d', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', fontSize: '12px' }}
//                   itemStyle={{ color: '#fff' }}
//                   cursor={{ fill: 'rgba(255,255,255,0.05)' }}
//                 />
//                 <Bar dataKey="count" radius={[4, 4, 0, 0]}>
//                   {chartData.map((_, i) => <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />)}
//                 </Bar>
//               </BarChart>
//             </ResponsiveContainer>
//           ) : (
//             <div className="h-40 flex items-center justify-center text-white/20 text-sm">No data yet</div>
//           )}
//         </div>

//         {/* Recent Quotations */}
//         <div className="card p-5">
//           <div className="flex items-center justify-between mb-4">
//             <div className="flex items-center gap-2">
//               <FileText size={15} className="text-primary-400" />
//               <h3 className="font-medium text-white text-sm">Recent Quotations</h3>
//             </div>
//             <Link to="/quotations" className="text-primary-400 text-xs hover:underline">View all</Link>
//           </div>
//           {loading ? (
//             <div className="space-y-2">{[...Array(4)].map((_, i) => <div key={i} className="skeleton h-12 rounded" />)}</div>
//           ) : stats?.recent_quotations?.length > 0 ? (
//             <div className="space-y-2">
//               {stats.recent_quotations.map(q => (
//                 <div key={q.id} className="flex items-center justify-between py-2 border-b border-white/5 last:border-0">
//                   <div>
//                     <div className="text-sm font-medium text-white">{q.name}</div>
//                     <div className="text-xs text-white/30">{q.project_type} · {q.location}</div>
//                   </div>
//                   <span className={`badge ${
//                     q.status === 'new' ? 'bg-blue-500/10 text-blue-400' :
//                     q.status === 'contacted' ? 'bg-green-500/10 text-green-400' :
//                     'bg-white/10 text-white/40'
//                   }`}>{q.status}</span>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="h-32 flex items-center justify-center text-white/20 text-sm">No quotations yet</div>
//           )}
//         </div>

//         {/* Activity Log */}
//         <div className="card p-5">
//           <div className="flex items-center gap-2 mb-4">
//             <Activity size={15} className="text-primary-400" />
//             <h3 className="font-medium text-white text-sm">Recent Activity</h3>
//           </div>
//           {loading ? (
//             <div className="space-y-2">{[...Array(5)].map((_, i) => <div key={i} className="skeleton h-10 rounded" />)}</div>
//           ) : stats?.recent_activity?.length > 0 ? (
//             <div className="space-y-1">
//               {stats.recent_activity.map(log => (
//                 <div key={log.id} className="flex items-start gap-3 py-2 border-b border-white/5 last:border-0">
//                   <div className="w-6 h-6 rounded-full bg-primary-500/10 flex items-center justify-center shrink-0 mt-0.5">
//                     <Clock size={10} className="text-primary-400" />
//                   </div>
//                   <div className="flex-1 min-w-0">
//                     <div className="text-xs text-white/70 truncate">{log.description}</div>
//                     <div className="text-[10px] text-white/25 mt-0.5">
//                       {log.user?.name} · {new Date(log.created_at).toLocaleDateString()}
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="h-32 flex items-center justify-center text-white/20 text-sm">No activity yet</div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FolderKanban, FileText, MessageSquare, Star, TrendingUp, Clock, ChevronRight, Activity, Users } from 'lucide-react';
import { getDashboardStats } from '../utils/api';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';

/* ── Animated count-up hook ── */
function useCountUp(target, { duration = 1000, enabled = true } = {}) {
  const [value, setValue] = useState(0);
  const rafRef = useRef(null);

  useEffect(() => {
    if (!enabled || target === 0) return;
    const startTime = performance.now();
    const easeOut = t => 1 - Math.pow(1 - t, 3);

    const tick = now => {
      const t = Math.min((now - startTime) / duration, 1);
      setValue(Math.round(easeOut(t) * target));
      if (t < 1) rafRef.current = requestAnimationFrame(tick);
    };

    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [target, duration, enabled]);

  return value;
}

/* ── Pulse dot for "live" indicator ── */
function PulseDot() {
  return (
    <span className="relative flex items-center justify-center w-2 h-2">
      <span className="absolute inline-flex w-full h-full rounded-full bg-green-400 opacity-60 animate-ping" />
      <span className="relative inline-flex w-2 h-2 rounded-full bg-green-400" />
    </span>
  );
}

/* ── Standard stat card ── */
function StatCard({ icon: Icon, label, value, sub, color = 'primary', to }) {
  const colors = {
    primary: 'bg-primary-500/10 text-primary-400 border-primary-500/20',
    blue:    'bg-blue-500/10 text-blue-400 border-blue-500/20',
    green:   'bg-green-500/10 text-green-400 border-green-500/20',
    purple:  'bg-purple-500/10 text-purple-400 border-purple-500/20',
  };
  const content = (
    <div className="card p-5 hover:border-white/15 transition-colors">
      <div className="flex items-start justify-between mb-4">
        <div className={`p-2.5 rounded-xl border ${colors[color]}`}>
          <Icon size={18} />
        </div>
        {to && <ChevronRight size={14} className="text-white/20" />}
      </div>
      <div className="text-2xl font-bold text-white mb-0.5">{value}</div>
      <div className="text-white/50 text-sm">{label}</div>
      {sub && <div className="text-xs text-white/30 mt-1">{sub}</div>}
    </div>
  );
  return to ? <Link to={to}>{content}</Link> : content;
}

/* ── New Users card with count-up animation ── */
function NewUsersCard({ value = 0, weeklyChange = 0, loading }) {
  const [visible, setVisible] = useState(false);

  // Trigger animation shortly after mount
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 150);
    return () => clearTimeout(t);
  }, []);

  const animated = useCountUp(value, { duration: 1100, enabled: visible && !loading });

  if (loading) {
    return (
      <div className="card p-5">
        <div className="skeleton h-10 w-10 rounded-xl mb-4" />
        <div className="skeleton h-7 w-16 rounded mb-1" />
        <div className="skeleton h-4 w-24 rounded" />
      </div>
    );
  }

  const changePositive = weeklyChange >= 0;

  return (
    <div
      className="card p-5 hover:border-white/15 transition-colors relative overflow-hidden"
      style={{
        animation: 'newUsersPop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both',
        animationDelay: '0.05s',
      }}
    >
      {/* Subtle corner glow */}
      <div
        className="absolute top-0 right-0 w-16 h-16 pointer-events-none"
        style={{
          background: 'radial-gradient(circle at top right, rgba(34,197,94,0.12), transparent 70%)',
        }}
      />

      {/* Header row */}
      <div className="flex items-start justify-between mb-4">
        <div className="p-2.5 rounded-xl border bg-green-500/10 text-green-400 border-green-500/20">
          <Users size={18} />
        </div>
        <div className="flex items-center gap-1.5">
          <PulseDot />
          <span className="text-[10px] font-semibold tracking-widest text-green-400 uppercase">Live</span>
        </div>
      </div>

      {/* Animated value */}
      <div
        className="text-2xl font-bold text-white mb-0.5 tabular-nums"
        style={{ animation: 'countSlideIn 0.4s ease both', animationDelay: '0.3s' }}
      >
        {animated.toLocaleString()}
      </div>

      <div className="text-white/50 text-sm">New Users</div>

      {/* Weekly change badge */}
      {weeklyChange !== 0 && (
        <div className="mt-2">
          <span
            className={`inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full ${
              changePositive
                ? 'bg-green-500/10 text-green-400'
                : 'bg-red-500/10 text-red-400'
            }`}
          >
            {changePositive ? '▲' : '▼'} {Math.abs(weeklyChange)}% this week
          </span>
        </div>
      )}

      {/* Keyframes injected once */}
      <style>{`
        @keyframes newUsersPop {
          from { opacity: 0; transform: scale(0.88) translateY(8px); }
          to   { opacity: 1; transform: scale(1) translateY(0); }
        }
        @keyframes countSlideIn {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

/* ── Skeleton ── */
function SkeletonStat() {
  return (
    <div className="card p-5">
      <div className="skeleton h-10 w-10 rounded-xl mb-4" />
      <div className="skeleton h-7 w-16 rounded mb-1" />
      <div className="skeleton h-4 w-24 rounded" />
    </div>
  );
}

const CHART_COLORS = ['#dc7b28', '#e49446', '#f5d6ad', '#aa4a1a', '#cd621d', '#faecd6'];

export default function DashboardPage() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDashboardStats()
      .then(r => setStats(r.data.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const chartData = stats?.projects_by_type?.map(item => ({
    name: item.project_type,
    count: item.count,
  })) || [];

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-xl font-semibold text-white">Dashboard</h1>
        <p className="text-white/40 text-sm mt-0.5">Overview of your portfolio platform</p>
      </div>

      {/* Stats Grid — 5 columns on large screens */}
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
        {loading ? (
          [...Array(5)].map((_, i) => <SkeletonStat key={i} />)
        ) : (
          <>
            <StatCard
              icon={FolderKanban}
              label="Total Projects"
              value={stats?.total_projects || 0}
              sub={`${stats?.active_projects} active`}
              color="primary"
              to="/projects"
            />
            <StatCard
              icon={FileText}
              label="Quotations"
              value={stats?.total_quotations || 0}
              sub={`${stats?.new_quotations} new`}
              color="blue"
              to="/quotations"
            />
            <StatCard
              icon={MessageSquare}
              label="Contacts"
              value={stats?.total_contacts || 0}
              sub={`${stats?.unread_contacts} unread`}
              color="green"
              to="/contacts"
            />
            <StatCard
              icon={Star}
              label="Featured"
              value={stats?.featured_projects || 0}
              sub="featured projects"
              color="purple"
              to="/projects"
            />
            {/* ── New Users card ── */}
            <NewUsersCard
              value={stats?.new_users || 0}
              weeklyChange={stats?.new_users_weekly_change ?? 18}
              loading={false}
            />
          </>
        )}
      </div>

      <div className="grid lg:grid-cols-3 gap-4">
        {/* Chart */}
        <div className="card p-5 lg:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <TrendingUp size={15} className="text-primary-400" />
            <h3 className="font-medium text-white text-sm">Projects by Type</h3>
          </div>
          {loading ? (
            <div className="skeleton h-40 rounded" />
          ) : chartData.length > 0 ? (
            <ResponsiveContainer width="100%" height={160}>
              <BarChart data={chartData} margin={{ top: 0, right: 0, left: -20, bottom: 0 }}>
                <XAxis dataKey="name" tick={{ fill: 'rgba(255,255,255,0.3)', fontSize: 10 }} axisLine={false} tickLine={false} />
                <YAxis tick={{ fill: 'rgba(255,255,255,0.3)', fontSize: 10 }} axisLine={false} tickLine={false} />
                <Tooltip
                  contentStyle={{ background: '#252d3d', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', fontSize: '12px' }}
                  itemStyle={{ color: '#fff' }}
                  cursor={{ fill: 'rgba(255,255,255,0.05)' }}
                />
                <Bar dataKey="count" radius={[4, 4, 0, 0]}>
                  {chartData.map((_, i) => <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />)}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <div className="h-40 flex items-center justify-center text-white/20 text-sm">No data yet</div>
          )}
        </div>

        {/* Recent Quotations */}
        <div className="card p-5">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <FileText size={15} className="text-primary-400" />
              <h3 className="font-medium text-white text-sm">Recent Quotations</h3>
            </div>
            <Link to="/quotations" className="text-primary-400 text-xs hover:underline">View all</Link>
          </div>
          {loading ? (
            <div className="space-y-2">{[...Array(4)].map((_, i) => <div key={i} className="skeleton h-12 rounded" />)}</div>
          ) : stats?.recent_quotations?.length > 0 ? (
            <div className="space-y-2">
              {stats.recent_quotations.map(q => (
                <div key={q.id} className="flex items-center justify-between py-2 border-b border-white/5 last:border-0">
                  <div>
                    <div className="text-sm font-medium text-white">{q.name}</div>
                    <div className="text-xs text-white/30">{q.project_type} · {q.location}</div>
                  </div>
                  <span className={`badge ${
                    q.status === 'new'       ? 'bg-blue-500/10 text-blue-400' :
                    q.status === 'contacted' ? 'bg-green-500/10 text-green-400' :
                                              'bg-white/10 text-white/40'
                  }`}>{q.status}</span>
                </div>
              ))}
            </div>
          ) : (
            <div className="h-32 flex items-center justify-center text-white/20 text-sm">No quotations yet</div>
          )}
        </div>

        {/* Activity Log */}
        <div className="card p-5">
          <div className="flex items-center gap-2 mb-4">
            <Activity size={15} className="text-primary-400" />
            <h3 className="font-medium text-white text-sm">Recent Activity</h3>
          </div>
          {loading ? (
            <div className="space-y-2">{[...Array(5)].map((_, i) => <div key={i} className="skeleton h-10 rounded" />)}</div>
          ) : stats?.recent_activity?.length > 0 ? (
            <div className="space-y-1">
              {stats.recent_activity.map(log => (
                <div key={log.id} className="flex items-start gap-3 py-2 border-b border-white/5 last:border-0">
                  <div className="w-6 h-6 rounded-full bg-primary-500/10 flex items-center justify-center shrink-0 mt-0.5">
                    <Clock size={10} className="text-primary-400" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-xs text-white/70 truncate">{log.description}</div>
                    <div className="text-[10px] text-white/25 mt-0.5">
                      {log.user?.name} · {new Date(log.created_at).toLocaleDateString()}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="h-32 flex items-center justify-center text-white/20 text-sm">No activity yet</div>
          )}
        </div>
      </div>
    </div>
  );
}